module.exports = __webpack_public_path__ + "static/media/slideshow.444f429f.svg";